import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "42",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#428542",
  d: "M15 0C6.75 0 0 6.447 0 14.382c0 3.141 1.083 6.117 3 8.596L14.333 37.69c.25.33.833.414 1.167.166l.167-.166L27 22.978c1.917-2.48 3-5.455 3-8.596C30 6.447 23.25 0 15 0"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  stroke: "#fff",
  "stroke-width": ".109",
  d: "M20.544 12.223c-.407 0-.796.08-1.157.22l-1.88-3.695h.846a.4.4 0 0 0 .395-.406.4.4 0 0 0-.395-.407h-1.498a.39.39 0 0 0-.338.196.42.42 0 0 0-.012.4l.964 1.894-3.314 2.283-1.542-2.504h1.316a.4.4 0 0 0 .394-.407.4.4 0 0 0-.394-.406H10.78c-.199-.924-1.061-1.618-2.096-1.618v1.005H7.377a.323.323 0 0 0-.318.33c0 .18.142.328.318.328h1.306v.728H7.377a.323.323 0 0 0-.318.328c0 .181.142.328.318.328h1.306v1.002c1.035 0 1.898-.695 2.097-1.619h.898l3.014 4.894h-.868c-.227-1.639-1.603-2.904-3.266-2.904-1.808 0-3.28 1.516-3.28 3.378 0 1.874 1.472 3.4 3.28 3.4 1.71 0 3.12-1.345 3.286-3.062h1.566c.144 0 .276-.08.346-.21a.42.42 0 0 0-.013-.413l-.58-.941 2.891-2.773.632 1.243a3.43 3.43 0 0 0-1.444 2.81c0 1.86 1.482 3.375 3.302 3.375 1.808 0 3.28-1.514 3.28-3.375 0-1.877-1.472-3.402-3.28-3.402Zm-9.986 5.987c-1.401 0-2.542-1.184-2.542-2.639 0-1.443 1.14-2.616 2.542-2.616 1.254 0 2.3.925 2.52 2.142h-2.662a.4.4 0 0 0-.395.406.4.4 0 0 0 .394.406h2.683c-.162 1.296-1.24 2.301-2.54 2.301Zm9.986.032c-1.414 0-2.564-1.174-2.564-2.617 0-.874.415-1.648 1.052-2.129l1.15 2.261c.071.139.21.218.35.218a.4.4 0 0 0 .184-.047.413.413 0 0 0 .166-.549l-1.15-2.258c.256-.088.528-.138.812-.138 1.4 0 2.54 1.185 2.54 2.642 0 1.444-1.14 2.617-2.54 2.617Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }